import React from 'react';

import './subcategory.scss';



const SubCategory = ({ title, description, projects }) => {
  return (
      <React.Fragment>
        <div className="services-container">
          <div className="als-text-container">
            <h2 className="services-container__header" dangerouslySetInnerHTML={{__html: title}} />
            <p className="services__text"
               dangerouslySetInnerHTML={{__html: description}}
            />
          </div>
          {
            projects && <div className="works-data" data-works-ids={projects.join(',')}/>
          }
        </div>
      </React.Fragment>
  );
}

export default SubCategory;
